import React, { useState } from 'react'
import '../../App.css'
import FormikComponent from '../Fomik/FormikComponent'
import FormComponent from '../React/Formik/FormComponent'
import './Contact.css'
import * as yup from "yup";
import { emailRegx } from '../../utils/regEx-pattern/regEx-pattern'

const feedback = [
    {
        label: "Full Name",
        name: "fullName",
        type: "text",
    },
    {
        label: "Email",
        name: "email",
        type: "text",
    },
    {
        label: "Your Message",
        name: "message",
        type: "textarea",
        row: 5,
        required: true,
    }
]

const mesageInitialValues = {
	fullName: "",
	email: "",
	message: "",
};
const messageValidationSchema = yup.object({
	fullName: yup.string().required("Full name is required"),
	email: yup
		.string()
		.matches(emailRegx, "Please input the valid email address")
		.required("Email is required"),
	message: yup.string().required("Message is required"),
});

export const Contact = () => {
	const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (values) => {
        console.log(values, "onsubmit");
    }
    return (

        <section className="contact_wrapper container-fluid" id="contact">
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4 order-2 order-lg-1 mb-lg-0 text-lg-start text-center contact">
                        <h3 className='text-center'>Get in Touch</h3>
                        <p className='mb-1'>If you or a founder you know has a revolutionary startup idea to help the world build future ,then Lacuna Venture Workshop Session wants to make it happen.</p>
                        <div className="row contact_detail mb-4 text-start ">
                            <label className="col-lg-4 col-sm-5  "><i className="fa-solid fa-phone-volume me-2 "></i>Phone:</label>
                            <div className="col-lg-8 col-sm-7 ab">
                                <a href="" >+977 00004775272</a>
                        
                            </div>

                            <label className="col-lg-4 col-sm-5 "><i className="fa-solid fa-square-envelope me-2 "></i>Email:</label>
                            <div className="col-lg-8 col-sm-7  ab">
                                <a href="">info@lacunaventure.com</a>
                            </div>
                            <label className="col-lg-4 col-sm-5 "><i className="fa-solid fa-location-dot me-2 "></i>Location:</label>
                            <div className="col-lg-8 col-sm-7 ab">
                                <a href="">Thapathali kathamandu</a>
                            </div>
                        </div>

                    </div>

                    <div class="order-1 order-lg-2 col-lg-8 mb-lg-0 mb-4 px-5 form">
                        <div class="row g-3 ">
                            <FormikComponent
                                initialValues={mesageInitialValues}
                                validationSchema={messageValidationSchema}
                                onSubmit={handleSubmit}
                            >
                                {feedback?.map((item, index) => (
                                    <div class="col-md-12" key={index}>
                                        <label for={item.name} className="form-label">{item.label}</label>
                                        <FormComponent type={item.type} name={item.name} label={item.label} row={item?.row} />
                                    </div>
                                ))}
                                
                                <div class="col-12">
                                    <button
                                        className="btn btn-pri"
                                        type="submit"
                                        disabled={isLoading}
                                    >
                                        Submit
                                    </button>
                                </div>  
                            </FormikComponent>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
